export default "__VITE_ASSET__CZyO_yYH__"